import {
  getMerchantInvoiceList,
  downloadMerchantInvoice,
  downloadMerchantInvoicePdf,
} from "../../services/MerchantInvoiceService";
import { formatError } from "../../services/commonServices";

export const MERCHANT_INVOICE_INITIATED = "MERCHANT_INVOICE_INITIATED";
export const MERCHANT_INVOICE_LOADED = "MERCHANT_INVOICE_LOADED";
export const MERCHANT_INVOICE_FAILED = "MERCHANT_INVOICE_FAILED";
export const MERCHANT_INVOICE_DOWNLOAD_INITIATED = "MERCHANT_INVOICE_DOWNLOAD_INITIATED";
export const MERCHANT_INVOICE_DOWNLOAD_LOADED = "MERCHANT_INVOICE_DOWNLOAD_LOADED";
export const MERCHANT_INVOICE_DOWNLOAD_FAILED = "MERCHANT_INVOICE_DOWNLOAD_FAILED";

export const loadMerchantInvoiceList = (getData) => {
  return (dispatch) => {
    dispatch({ type: MERCHANT_INVOICE_INITIATED });
    getMerchantInvoiceList(getData)
      .then((response) => {
        dispatch({ type: MERCHANT_INVOICE_LOADED, payload: response.data.data });
      })
      .catch((error) => {
        dispatch({ type: MERCHANT_INVOICE_FAILED, payload: error.message });
      });
  };
};

export const downloadInvoice = (getData, fileName) => {
  return async (dispatch) => {
    try {
      dispatch({ type: MERCHANT_INVOICE_DOWNLOAD_INITIATED });
      const response = await downloadMerchantInvoice(getData);
      const name = fileName ? fileName : "invoice.csv";
      const blob = new Blob([response.data], { type: "application/octet-stream" });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = name;
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
      dispatch({ type: MERCHANT_INVOICE_DOWNLOAD_LOADED });
    } catch (error) {
      dispatch({
        type: MERCHANT_INVOICE_DOWNLOAD_FAILED,
        payload: error.response?.data ? formatError(error.response.data) : formatError(error.message),
      });
    }
  };
};

export const downloadInvoicePdf = (getData, fileName) => {
  return async (dispatch) => {
    try {
      dispatch({ type: MERCHANT_INVOICE_DOWNLOAD_INITIATED });
      const response = await downloadMerchantInvoicePdf(getData);
      const name = fileName ? fileName : "invoice.pdf";
      const blob = new Blob([response.data], { type: "application/pdf" });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = name;
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
      dispatch({ type: MERCHANT_INVOICE_DOWNLOAD_LOADED });
    } catch (error) {
      dispatch({
        type: MERCHANT_INVOICE_DOWNLOAD_FAILED,
        payload: error.response?.data ? formatError(error.response.data) : formatError(error.message),
      });
    }
  };
};
